import React from "react";
import { Alert, AlertTitle } from "@mui/material";
import { useQuery } from "@apollo/client";
import { GET_LAST_DAILY_TASK, tokenOptions } from "../../backend/graphql";
import { useAppSelector } from "../../app/hooks";
import { seesAdminData } from "../../app/features/auth/authTypes";
import { asUTC, formatDateTime } from "../../tools";
import NavButton from "./NavButton";

// Says, on every screen, that the last nightly maintenance run did not finish cleanly — the run
// syncs the stock, analyzes the new pictures and re-prices, so a night lost is a day of stale
// data that nothing else on the app would mention. Admins only: they are the ones who can look
// at the task and start it again.
const DailyStatusBanner = () => {
  const token = useAppSelector((state) => state.auth.token);
  const role = useAppSelector((state) => state.auth.role);
  const { data } = useQuery(GET_LAST_DAILY_TASK, {
    ...tokenOptions(token),
    skip: !seesAdminData(role),
  });

  const daily = data?.lastDailyTask;
  if (!daily?.isError) return null;

  const ranAt = formatDateTime(asUTC(daily.createdAt));

  return (
    <Alert
      severity="error"
      sx={{ mb: 2 }}
      action={
        <NavButton
          size="small"
          onClick={() => window.open("/tasks", "_blank")}
        >
          Tasks
        </NavButton>
      }
    >
      <AlertTitle>The nightly run of {ranAt} did not finish</AlertTitle>
      {daily.errorMessage}
    </Alert>
  );
};

export default DailyStatusBanner;
